import { Button, Checkbox, Col, Form, Row } from "antd";
import { useEffect, useMemo, useState } from "react";
import { getDimensions, getMetrics } from "services/apiRequest";

export default function FillterTable(props) {
    const { metricId, dimensionId, dataFields, onFieldsChange } = props;

    const [initFillter, setInitFillter] = useState(false);

    const [defaultData, setDefaultData] = useState({ dimensions: [], metrics: [] });

    useEffect(() => {
        if (!metricId || !dimensionId) {
            return;
        }

        const fetchData = async (dimensionId, metricId) => {
            try {
                // Chạy cả hai lời gọi bất đồng bộ song song
                const [dimensions, metrics] = await Promise.all([
                    getDimensions(dimensionId), // Lấy dimensions
                    getMetrics(metricId),       // Lấy metrics
                ]);

                // Gán kết quả vào đối tượng
                const obj = {
                    dimensions: dimensions?.data,
                    metrics: metrics?.data,
                };

                return obj;
            } catch (error) {
                console.error("Error fetching data:", error);
                throw error; // Bắn lỗi để xử lý nếu cần
            }
        };

        fetchData(metricId, dimensionId).then((data) => setDefaultData(data))
            .catch((error) => console.error("Failed to fetch data:", error));
        ;

    }, [metricId, dimensionId]);

    const [form] = Form.useForm();

    useEffect(() => {
        if (!dataFields || initFillter) {
            return;
        }

        setInitFillter(true);

        Object.entries(dataFields).forEach(([key, values]) => {
            values.forEach((element) => {
                form.setFieldValue(`${key}-${element}`, true);
            });
        });
    }, [dataFields, initFillter]);

    const allValues = Form.useWatch([], form);

    const disabled = useMemo(() => {

        if (!allValues) {
            return true
        }

        // Lọc các key chứa "metricIds" và "dimensionIds"
        const metricIds = Object.keys(allValues).filter(key => key.startsWith('metricIds'));
        const dimensionIds = Object.keys(allValues).filter(key => key.startsWith('dimensionIds'));

        // Kiểm tra nếu tất cả các value tương ứng đều không có giá trị
        const allMetricIdsEmpty = metricIds.every(key => !allValues[key]);
        const allDimensionIdsEmpty = dimensionIds.every(key => !allValues[key]);

        // Trả về true nếu 1 trong hai rỗng, false nếu có bất kỳ giá trị nào
        return allMetricIdsEmpty || allDimensionIdsEmpty;
    }, [allValues])

    function groupIds(data) {
        const result = {
            dimensionIds: [],
            metricIds: [],
        };

        // Duyệt qua tất cả các key-value trong object
        Object.entries(data).forEach(([key, value]) => {
            if (value === true) {
                // Kiểm tra nếu key bắt đầu bằng dimensionIds
                if (key.startsWith("dimensionIds")) {
                    const id = key.split("-")[1]; // Lấy ID từ key (sau dấu '-')
                    result.dimensionIds.push(Number(id)); // Đưa ID vào mảng dimensionIds
                }
                // Kiểm tra nếu key bắt đầu bằng metricIds
                if (key.startsWith("metricIds")) {
                    const id = key.split("-")[1]; // Lấy ID từ key (sau dấu '-')
                    result.metricIds.push(Number(id)); // Đưa ID vào mảng metricIds
                }
            }
        });

        onFieldsChange(result);
    }

    return <Form
        form={form}
        onFinish={(values) => {
            groupIds(values);
        }}
    >
        <Col
            className="bg-gray-100 w-full rounded-md p-3">
            <div className="flex flex-col justify-between pt-3 pb-3 w-full">
                <b>Dimension</b>
                <div className="w-full">
                    {defaultData?.dimensions?.map((item, index) => {
                        return (
                            <div key={index} className="col d-flex align-items-center gap-2">
                                <Form.Item
                                    valuePropName="checked"
                                    name={`dimensionIds-${item?.id}`}
                                    style={{ padding: 0, margin: 0 }}
                                >
                                    <Checkbox>
                                        {item.name}
                                    </Checkbox>
                                </Form.Item>
                            </div>
                        );
                    })}
                </div>

                <b>Metrics</b>

                <div>
                    {defaultData?.metrics?.map((item, index) => {
                        return (
                            <div key={index} className="col d-flex align-items-center gap-2">
                                <Form.Item
                                    valuePropName="checked"
                                    name={`metricIds-${item?.id}`}
                                    style={{ padding: 0, margin: 0 }}
                                >
                                    <Checkbox>
                                        {item.name}
                                        {item.value}
                                    </Checkbox>
                                </Form.Item>
                            </div>
                        );
                    })}
                </div>

                <div className="pt-5 text-center">
                    <Button
                        type="primary"
                        disabled={disabled}
                        onClick={() => {
                            form.submit();
                        }}
                    >
                        Áp dụng
                    </Button>
                </div>
            </div>
        </Col>
    </Form>
} 